// Central site data. Placeholders for NAP, services structure used by Services page anchors.
export const CONTACT = {
  phoneLabel: "(365) 360-ALAE",
  phoneTel: "+13653602523",
  email: "info@alaedental.com",
  address: "9097 Jane St, Vaughan, ON L4K 0R7",
  addressLines: ["9097 Jane St", "Vaughan, ON L4K 0R7"],
  hours: [
    { days: "Mon", time: "9:00 to 19:00" },
    { days: "Tue", time: "9:00 to 18:00" },
    { days: "Wed", time: "9:00 to 19:00" },
    { days: "Thu", time: "9:00 to 18:00" },
    { days: "Fri", time: "9:00 to 18:00" },
    { days: "Sat", time: "9:00 to 15:00" },
  ],
  mapQuery: "9097 Jane St, Vaughan, ON L4K 0R7",
};

// External integrations
export const BOOKING_URL = "https://alaedental.oralhealth.app/book/";
export const GBP_URL = "https://share.google/vbMVUKWxdc1JV4puy";
export const INSTAGRAM_URL = "https://www.instagram.com/alaedental/";
export const FACEBOOK_URL = "https://www.facebook.com/alaedental";

// Real photography
export const PORTRAIT = {
  drMirza: "/assets/dr-mirza.jpg",
  drMirzaAlt:
    "Dr. Nausheen Mirza, General Dentist and founder of Alae Dental in Vaughan",
};

export const SERVICE_OVERVIEW = [
  {
    key: "preventative",
    number: "01",
    title: "Preventive & Routine Care",
    blurb:
      "Exams, oral cancer screening, cleanings, imaging, and children's dentistry.",
  },
  {
    key: "restorative",
    number: "02",
    title: "Restorative Dentistry",
    blurb:
      "Fillings, crowns and bridges, root canal therapy, dentures, and implants.",
  },
  {
    key: "cosmetic",
    number: "03",
    title: "Cosmetic Dentistry",
    blurb:
      "Veneers, teeth whitening, Invisalign clear aligners, and smile makeovers.",
  },
  {
    key: "implants",
    number: "04",
    title: "Tooth Replacement & Implants",
    blurb:
      "Options for replacing missing teeth, planned around your oral health and goals.",
  },
  {
    key: "specialized",
    number: "05",
    title: "Comfort & Additional Care",
    blurb:
      "Night guards, sports guards, and therapeutic Botox.",
  },
  {
    key: "emergency",
    number: "06",
    title: "Emergency Dentistry",
    blurb:
      "Prompt assessment and care for dental pain, infection, and injury.",
  },
];

export const SERVICE_DETAIL = [
  {
    key: "preventative",
    title: "Preventive & Routine Care",
    tagline:
      "Supporting lifelong oral health through prevention, early detection, and personalized care.",
    items: [
      {
        name: "Comprehensive Dental Exams & Oral Cancer Screening",
        body:
          "Our comprehensive examinations assess your teeth, gums, jaw, and overall oral health, and include a routine oral cancer screening. We take the time to understand your dental history, concerns and goals so your care can be planned around your individual needs.",
      },
      {
        name: "Professional Cleanings & Preventive Care",
        body:
          "Personalized dental hygiene care helps remove plaque and tartar, maintain healthy teeth and gums and prevent oral disease. We also provide guidance to help you care for your smile between visits.",
      },
      {
        name: "Digital X-Rays & Panoramic Imaging",
        body:
          "Digital X-rays and panoramic imaging provide detailed views of your teeth and surrounding structures to support diagnosis and treatment planning.",
      },
      {
        name: "Children's Dentistry",
        body:
          "We take a gentle, welcoming approach to children's dental care, helping young patients become comfortable with dental visits while building healthy habits from an early age.",
      },
      {
        name: "Fluoride Treatments & Sealants",
        body:
          "Fluoride treatments can help strengthen enamel and reduce the risk of decay, while dental sealants provide an added layer of protection to the deep grooves of teeth that may be more vulnerable to cavities.",
      },
    ],
  },
  {
    key: "restorative",
    title: "Restorative Dentistry",
    tagline:
      "Personalized care focused on restoring the health, function, and appearance of damaged or missing teeth.",
    items: [
      {
        name: "Tooth-Coloured Fillings",
        body:
          "Tooth-coloured composite resin can be used to repair decay or damage while blending naturally with the surrounding tooth structure.",
      },
      {
        name: "Crowns & Bridges",
        body:
          "Custom crowns can help strengthen and restore damaged or weakened teeth, while bridges may be used to replace one or more missing teeth. Each restoration is planned with function, fit, and natural appearance in mind.",
      },
      {
        name: "Root Canal Therapy",
        body:
          "Root canal therapy is used to treat infection or inflammation within a tooth and may help preserve a natural tooth that might otherwise require extraction.",
      },
      {
        name: "Extractions & Wisdom Teeth",
        body:
          "Our priority is to preserve natural teeth whenever appropriate. When an extraction is necessary, we focus on making the experience as comfortable as possible. Wisdom teeth can also be assessed and removed when clinically appropriate.",
      },
      {
        name: "Dentures & Partial Dentures",
        body:
          "Full and partial dentures offer removable options for replacing missing teeth. Each is designed around the individual patient's needs to support function, appearance, and everyday comfort.",
      },
      {
        name: "Dental Implants & Implant Restorations",
        body:
          "Dental implants can provide a stable, long-term option for replacing missing teeth. From implant placement to the final restoration, treatment is carefully planned around your individual oral health, needs, and goals.",
      },
    ],
  },
  {
    key: "cosmetic",
    title: "Cosmetic Dentistry",
    tagline:
      "Personalized treatment options designed around your smile, features, and individual goals.",
    items: [
      {
        name: "Veneers",
        body:
          "Veneers are thin, custom-made restorations that can change the shape, colour, size, or proportions of selected teeth while complementing your natural features.",
      },
      {
        name: "Teeth Whitening",
        body:
          "Professional teeth whitening can help reduce the appearance of stains and discolouration. Treatment options are selected based on your oral health, individual needs, and desired outcome.",
      },
      {
        name: "Invisalign\u00AE Clear Aligners",
        body:
          "Invisalign clear aligners offer a discreet option for gradually moving teeth without traditional metal braces. Dr. Mirza is a General Dentist and has previously been recognized as an Invisalign Gold Provider. Treatment recommendations are based on your individual needs and goals.",
      },
      {
        name: "Smile Makeovers",
        body:
          "A smile makeover brings together selected cosmetic and restorative treatments in an individualized treatment plan based on your oral health, features, and personal goals.",
      },
    ],
  },
  {
    key: "specialized",
    title: "Comfort & Additional Care",
    tagline:
      "Additional care designed around comfort, protection, and your individual needs.",
    items: [
      {
        name: "Night Guards & Sports Guards",
        body:
          "Custom-made sports guards help protect teeth during athletic activity, while night guards may help protect the teeth from wear associated with nighttime grinding or clenching.",
      },
      {
        name: "Therapeutic Botox\u00AE",
        body:
          "Botox treatment is available for appropriate patients following an individual assessment, including certain concerns related to jaw muscle tension.",
      },
      {
        name: "Emergency Dentistry",
        body:
          "Dental emergencies can be stressful. We provide prompt, compassionate assessment and care for dental pain, infection, injury, and other urgent concerns, with treatment recommendations based on your individual needs.",
      },
    ],
  },
];

// Aliases used by Services-Overview cards to deep-link to the right section
export const SERVICE_KEY_TO_DETAIL_ANCHOR = {
  preventative: "preventative",
  restorative: "restorative",
  cosmetic: "cosmetic",
  implants: "restorative", // implants live inside Restorative section per copy
  specialized: "specialized",
  emergency: "specialized", // emergency lives inside Specialized Care section per copy
};

export const WAITLIST_SERVICES = [
  "Invisalign",
  "Cosmetic Dentistry",
  "Veneers",
  "Dental Implants",
  "General Dentistry",
  "Dental Cleanings & Preventive Care",
  "Teeth Whitening",
  "Emergency Dentistry",
  "Other",
];

export const WAITLIST_TIMING = ["Morning", "Afternoon", "Evening", "Weekend"];
export const WAITLIST_CONTACT_METHODS = ["Call", "Text", "Email"];

export const IMAGES = {
  hero:
    "https://images.unsplash.com/photo-1567016376408-0226e4d0c1ea?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzOTB8MHwxfHNlYXJjaHwxfHx3YXJtJTIwbWluaW1hbGlzdCUyMGludGVyaW9yJTIwYXJjaGl0ZWN0dXJlfGVufDB8fHx8MTc4Mjc0MjQ4Nnww&ixlib=rb-4.1.0&q=60&w=1800",
  philosophy:
    "https://images.unsplash.com/photo-1601993957728-1e56ab70c5a8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzOTB8MHwxfHNlYXJjaHwzfHx3YXJtJTIwbWluaW1hbGlzdCUyMGludGVyaW9yJTIwYXJjaGl0ZWN0dXJlfGVufDB8fHx8MTc4Mjc0MjQ4Nnww&ixlib=rb-4.1.0&q=55&w=900",
  experience:
    "https://images.unsplash.com/photo-1631125915902-d8abe9225ff2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwxfHxjZXJhbWljJTIwdmFzZSUyMG5ldXRyYWx8ZW58MHx8fHwxNzgyNzQyNDg2fDA&ixlib=rb-4.1.0&q=55&w=1100",
  servicesAccent:
    "https://images.unsplash.com/photo-1597696929736-6d13bed8e6a8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwyfHxjZXJhbWljJTIwdmFzZSUyMG5ldXRyYWx8ZW58MHx8fHwxNzgyNzQyNDg2fDA&ixlib=rb-4.1.0&q=55&w=1100",
  testimonials:
    "https://images.unsplash.com/photo-1600172454132-ada7faa101cf?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwxfHxib3RhbmljYWwlMjBzaGFkb3dzJTIwd2FsbHxlbnwwfHx8fDE3ODI3NDI0ODZ8MA&ixlib=rb-4.1.0&q=55&w=1100",
  linenTexture:
    "https://images.unsplash.com/photo-1528458909336-e7a0adfed0a5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHwyfHxsaW5lbiUyMGZhYnJpYyUyMHRleHR1cmUlMjBsaWdodHxlbnwwfHx8fDE3ODI3NDI0ODZ8MA&ixlib=rb-4.1.0&q=50&w=900",
  waitlist:
    "https://images.unsplash.com/photo-1700474568247-2bf81611b293?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzOTB8MHwxfHNlYXJjaHwyfHx3YXJtJTIwbWluaW1hbGlzdCUyMGludGVyaW9yJTIwYXJjaGl0ZWN0dXJlfGVufDB8fHx8MTc4Mjc0MjQ4Nnww&ixlib=rb-4.1.0&q=55&w=1100",
};
